import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import './MorePage.css';

export const MorePage: React.FC = () => {
  const { colors } = useTheme();
  const { t } = useLanguage();

  const features = [
    { icon: '📿', title: t.more.tasbih, path: '/tasbih', desc: t.more.count },
    { icon: '💰', title: t.more.zakat, path: '/zakat', desc: t.more.zakatDesc },
    { icon: '✨', title: t.more.namesOfAllah, path: '/names', desc: 'Beautiful names' },
    { icon: '📅', title: t.more.monthly, path: '/monthly', desc: 'Full month prayer times' },
    { icon: '🌙', title: t.more.hijri, path: '/hijri', desc: 'Islamic calendar' },
    { icon: '📰', title: t.more.events, path: '/events', desc: 'Important dates' },
    { icon: '📖', title: t.more.kahf, path: '/kahf', desc: 'Friday recitation' },
    { icon: '🤲', title: t.more.duas, path: '/duas', desc: 'Essential supplications' },
    { icon: '📊', title: t.more.stats, path: '/stats', desc: t.more.statsDesc },
    { icon: '👥', title: t.more.inheritance, path: '/inheritance', desc: t.more.inheritanceDesc },
    { icon: '🍴', title: t.more.halalPlaces, path: '/halal', desc: 'Find halal food' },
    { icon: '🚆', title: t.more.trains, path: '/trains', desc: 'Finland trains' },
    { icon: 'ℹ️', title: t.more.appInfo, path: '/appinfo', desc: 'About this app' },
  ];

  return (
    <div className="more-page" style={{ backgroundColor: colors.background, color: colors.text }}>
      <h2>{t.tabs.more}</h2>
      <div className="features-grid">
        {features.map((feature) => (
          <Link
            key={feature.path}
            to={feature.path}
            className="feature-card"
            style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}
          >
            <div className="feature-icon">{feature.icon}</div>
            <div className="feature-title" style={{ color: colors.text }}>{feature.title}</div>
            <div className="feature-desc" style={{ color: colors.muted }}>{feature.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};
